import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

import type { BannerProps } from './types';

const OutageBanner = () => import(/* webpackChunkName: "4-feat-outage-banner" */ './OutageBanner');

const LoadableOutageBanner: ComponentType<BannerProps> = lazyLoadOnRender({ loader: OutageBanner });
export default LoadableOutageBanner;
